import { HttpPrefix } from '../lib/wemeet-http-moudle';
import { get, post } from '../lib/http';
import useSWR, { SWRResponse } from 'swr';

type RequestParams = Record<string, any> | (() => Record<string, any>);
type ParamsOrParamsFunc<T> = T | (() => T);

type IMakeEventSWR = <P extends RequestParams, U>(
  url: string,
  method: 'get' | 'post',
  map?: (data: any) => U,
) => (params: ParamsOrParamsFunc<P>) => SWRResponse<U>;

export const makeEventSWR: IMakeEventSWR =
  <T>(url: string, method: 'get' | 'post' = 'post', map?: (data: any) => any) =>
  (params: RequestParams) => {
    const condition = () => ({
      url,
      params: typeof params === 'function' ? params() : params,
    });
    return useSWR(
      condition,
      ({ url, params }: { url: string; params: RequestParams }) => {
        const methods = { post, get } as const;
        return methods[method](HttpPrefix.WEMEET_TAPI, url, params)
          .then((res) => {
            if (res.code !== 0) {
              return Promise.reject(res.msg || res.err_detail);
            }
            return res.data || {};
          })
          .then((data) => (map ? map(data) : data) as T);
      },
      {
        revalidateOnFocus: false,
      },
    );
  };
